/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Domain_CatalogInputs */

const en_search_domain_catalog = /** @type {(inputs: Search_Domain_CatalogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the catalog`)
};

/**
* | output |
* | --- |
* | "the catalog" |
*
* @param {Search_Domain_CatalogInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const search_domain_catalog = /** @type {((inputs?: Search_Domain_CatalogInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Domain_CatalogInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_search_domain_catalog(inputs)
});